var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      !_vm.inputConfirmCode
        ? _c(
            "form",
            {
              on: {
                submit: function ($event) {
                  $event.preventDefault()
                  return _vm.submit.apply(null, arguments)
                },
              },
            },
            [
              _vm.contestRedirect
                ? _c("p", { staticClass: "contest-entry-notice" }, [
                    _vm._v(_vm._s(_vm.$t("signUpPage.contestEntryNotice"))),
                  ])
                : _vm._e(),
              _c("h1", [_vm._v(_vm._s(_vm.$t("signUpPage.title")))]),
              _c(
                "router-link",
                {
                  staticClass: "sign-in-link",
                  attrs: { to: _vm.signInLocation },
                },
                [_vm._v(_vm._s(_vm.$t("signUpPage.signInLink")))]
              ),
              _vm.message
                ? _c("div", { staticClass: "message" }, [
                    _vm._v(_vm._s(_vm.message)),
                  ])
                : _vm._e(),
              _vm.errorMessage
                ? _c("div", { staticClass: "error-message" }, [
                    _vm._v(_vm._s(_vm.errorMessage)),
                  ])
                : _vm._e(),
              _c("text-field", {
                staticClass: "input",
                attrs: {
                  type: "email",
                  name: "email",
                  label: _vm.$t("signUpPage.emailLabel"),
                  placeholder: _vm.$t("signUpPage.emailPlaceholder"),
                },
                model: {
                  value: _vm.email,
                  callback: function ($$v) {
                    _vm.email = $$v
                  },
                  expression: "email",
                },
              }),
              _c("text-field", {
                staticClass: "input",
                attrs: {
                  type: "password",
                  label: _vm.$t("signUpPage.passwordLabel"),
                  placeholder: _vm.$t("signUpPage.passwordPlaceholder"),
                },
                model: {
                  value: _vm.password,
                  callback: function ($$v) {
                    _vm.password = $$v
                  },
                  expression: "password",
                },
              }),
              _c("text-field", {
                staticClass: "input",
                attrs: {
                  type: "password",
                  label: _vm.$t("signUpPage.passwordConfirmLabel"),
                  placeholder: _vm.$t("signUpPage.passwordConfirmPlaceholder"),
                },
                model: {
                  value: _vm.passwordConfirm,
                  callback: function ($$v) {
                    _vm.passwordConfirm = $$v
                  },
                  expression: "passwordConfirm",
                },
              }),
              _c("div", { staticClass: "attention" }, [
                _vm._v(_vm._s(_vm.$t("signUpPage.passwordRequirement"))),
              ]),
              _c(
                "div",
                { staticClass: "sign-up-container" },
                [
                  _c("p", { staticClass: "sign-up-txt" }, [
                    _vm._v(
                      " " + _vm._s(_vm.$t("signUpPage.agreementText")) + " "
                    ),
                    _c("a", { attrs: { href: "/terms", target: "_blank" } }, [
                      _vm._v(_vm._s(_vm.$t("signUpPage.termsOfService"))),
                    ]),
                    _vm._v(_vm._s(_vm.$t("signUpPage.and"))),
                    _c("a", { attrs: { href: "/privacy", target: "_blank" } }, [
                      _vm._v(_vm._s(_vm.$t("signUpPage.privacyPolicy"))),
                    ]),
                    _c("span", {
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.$t("signUpPage.agreementTextSuffix")
                        ),
                      },
                    }),
                  ]),
                  _vm.currentLocale === "ja"
                    ? _c(
                        "checkbox-item",
                        {
                          staticClass: "email-magazine-checkbox",
                          model: {
                            value: _vm.subscribeEmailMagazine,
                            callback: function ($$v) {
                              _vm.subscribeEmailMagazine = $$v
                            },
                            expression: "subscribeEmailMagazine",
                          },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t("signUpPage.subscribeEmailMagazine")
                              ) +
                              " "
                          ),
                        ]
                      )
                    : _vm._e(),
                  _c(
                    "button-default",
                    {
                      staticClass: "enrollment-button",
                      attrs: { disabled: _vm.submitting },
                    },
                    [
                      _vm.submitting
                        ? _c(
                            "span",
                            { staticClass: "enrollment-button-content" },
                            [
                              _c("icon-spinner", {
                                staticClass: "enrollment-button-spinner",
                              }),
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("signUpPage.signingUp")) +
                                  " "
                              ),
                            ],
                            1
                          )
                        : _c("span", [
                            _vm._v(_vm._s(_vm.$t("signUpPage.signUpButton"))),
                          ]),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "setting" },
                [
                  _c(
                    "router-link",
                    {
                      attrs: {
                        to: {
                          name: "resendConfirmCode",
                          params: { propEmail: _vm.email },
                        },
                      },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(_vm.$t("signUpPage.resendConfirmCode")) +
                          " "
                      ),
                    ]
                  ),
                  _c(
                    "a",
                    {
                      attrs: {
                        href: `${_vm.help}#a9ab790429a64fae9489d2ac06671565`,
                        target: "_blank",
                      },
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("signUpPage.confirmCodeNotDelivered"))
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _c("sign-up-confirm-code", {
            attrs: { email: _vm.email },
            on: { complete: _vm.complete },
          }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }